import { axios } from '@/lib/axios';

export const updateUser = (userId, data) => {
  return axios.put(`/users/${userId}`, data);
};
